import qs from 'qs'
import { ApiParams } from '../../../../types/commonTypes'
import {
  InsuranceDetailsProps,
  InsuranceDetailsResponse,
  InsuranceUploadProps,
  viewInsuranceDetailsResponse,
} from '../../../../types/Finance/Insurance/insuranceTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, insuranceApiConfig } from '../../apiList'

const uploadFolder = async (props: InsuranceUploadProps): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: insuranceApiConfig.uploadFolder,
    method: AllowedHttpMethods.post,
    data: props.file,
    params: {
      isFolder: props.isFoldeUpload,
      year: props.year,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getInsuranceDetails = async (
  props: InsuranceDetailsProps,
): Promise<InsuranceDetailsResponse> => {
  const empId = localStorage.getItem('employeeId') as string
  const requestConfig = getAuthenticatedRequestConfig({
    url: insuranceApiConfig.getInsuranceDetails,
    method: AllowedHttpMethods.get,
    params: {
      startIndex: props.startIndex,
      endIndex: props.endIndex,
      year: props.year,
      search: props.search,
      status: props?.status === 'Me' ? empId : props?.status,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const downloadInsurance = async ({
  empId,
  year,
}: {
  empId: number
  year: string
}): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: insuranceApiConfig.downloadInsurance,
    method: AllowedHttpMethods.get,
    params: {
      empId,
      year,
    },
    responseType: 'blob',
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const deleteMultipleInsuranceDetails = async (
  insuranceId: number[],
): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: insuranceApiConfig.deleteMultipleInsurance,
    method: AllowedHttpMethods.delete,
    params: { insuranceId },
    paramsSerializer: (params: ApiParams) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const saveInsurance = async ({
  empId,
  year,
}: {
  empId: number
  year: string
}): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: insuranceApiConfig.saveInsurance,
    method: AllowedHttpMethods.post,
    params: {
      empId,
      year,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const viewInsuranceDetails =
  async (): Promise<viewInsuranceDetailsResponse> => {
    const requestConfig = getAuthenticatedRequestConfig({
      url: insuranceApiConfig.viewInsurance,
      method: AllowedHttpMethods.get,
    })
    const response = await useAxios(requestConfig)
    return response.data
  }

export const insuranceApi = {
  uploadFolder,
  getInsuranceDetails,
  downloadInsurance,
  viewInsuranceDetails,
  deleteMultipleInsuranceDetails,
  saveInsurance,
}
